module.exports = __webpack_public_path__ + "img/371-5f868c.png";